export const SITE_URL = 'https://isadorafoods.com';

// Canonical absoluto con el dominio de producción, sin query string ni hash.
export const canonicalUrl = (pathname = window.location.pathname) =>
    SITE_URL + pathname;

const htmlToText = html =>
    new DOMParser()
        .parseFromString(html || '', 'text/html')
        .body.textContent.replace(/\s+/g, ' ')
        .trim();

const cleanText = text => (text || '').replace(/\s+/g, ' ').trim();

// Convierte HTML de la API en texto plano apto para meta description.
export const toMetaDescription = (html = '', maxLength = 155) => {
    const text = cleanText(htmlToText(html));
    if (text.length <= maxLength) return text;
    const cut = text.slice(0, maxLength);
    return cut.slice(0, cut.lastIndexOf(' ')).replace(/[\s,.;:]+$/, '') + '…';
};

// "BEAN DIP" -> "Bean Dip" (los títulos de recetas vienen en mayúsculas).
export const toTitleCase = (text = '') =>
    cleanText(text)
        .toLowerCase()
        .replace(/(^|[\s(-])(\p{L})/gu, (m, sep, letter) => sep + letter.toUpperCase());

const BRAND = { '@type': 'Brand', '@id': `${SITE_URL}/#brand`, name: 'Isadora' };

export const productJsonLd = (product, imageBaseUrl) => ({
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: `Isadora ${product.title}`,
    url: canonicalUrl(),
    image: [product.active_image, product.backside_imagen]
        .filter(Boolean)
        .map(image => `${imageBaseUrl}/storage/${image}`),
    description: toMetaDescription(product.details, 500),
    brand: BRAND,
});

export const recipeJsonLd = (recipe, imageBaseUrl) => {
    const steps = Array.from(
        new DOMParser()
            .parseFromString(recipe.preparation || '', 'text/html')
            .querySelectorAll('p, li')
    )
        .map(el => cleanText(el.textContent))
        .filter(Boolean);
    const minutes = parseInt(recipe.cooking_time, 10);

    return {
        '@context': 'https://schema.org',
        '@type': 'Recipe',
        name: toTitleCase(recipe.title),
        url: canonicalUrl(),
        image: [`${imageBaseUrl}/storage/recipes/${recipe.image}`],
        description: toMetaDescription(recipe.description, 500),
        author: { '@type': 'Organization', name: 'Isadora Beans', url: SITE_URL },
        ...(minutes > 0 && { totalTime: `PT${minutes}M` }),
        recipeIngredient: (recipe.ingredient || [])
            .filter(ingredient => !ingredient.is_subtitle)
            .map(ingredient => cleanText(ingredient.description))
            .filter(Boolean),
        recipeInstructions: steps.map(text => ({ '@type': 'HowToStep', text })),
    };
};
